export default __webpack_public_path__ + "static/media/caloIndoorLogo.50aad77e.svg";